import { render, staticRenderFns } from "./FormDownload.vue?vue&type=template&id=8f3e2108&"
import script from "./FormDownload.vue?vue&type=script&lang=js&"
export * from "./FormDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports